import { PRICING } from '@/features/onboarding/data';

type OnboardingTranslate = (key: string, options?: Record<string, unknown>) => string;

export function getOnboardingPrice(sourceCount: number): number {
    const quantity = Math.max(PRICING.included, Math.round(sourceCount));

    return quantity <= PRICING.included
        ? PRICING.base
        : PRICING.base + (quantity - PRICING.included) * PRICING.perExtra;
}

export function getOnboardingPriceBreakdown(sourceCount: number, t?: OnboardingTranslate): string {
    const quantity = Math.max(PRICING.included, Math.round(sourceCount));

    if (quantity <= PRICING.included) {
        if (t) {
            return t('onboardingFlow.activate.breakdownIncluded', {
                count: PRICING.included,
                price: PRICING.base
            });
        }

        return `${PRICING.included} sources included in the $${PRICING.base} base`;
    }

    const extraCount = quantity - PRICING.included;

    if (t) {
        return t('onboardingFlow.activate.breakdownExpanded', {
            base: PRICING.base,
            extraCount,
            extraPrice: PRICING.perExtra
        });
    }

    return `$${PRICING.base} base + ${extraCount} × $${PRICING.perExtra}`;
}

export function formatOnboardingPrice(sourceCount: number, t?: OnboardingTranslate): string {
    const price = getOnboardingPrice(sourceCount);

    if (t) {
        return t('onboardingFlow.pricePerMonth', { price });
    }

    return `$${price}/mo`;
}
